import React from 'react'
import { Pie } from 'react-chartjs-2'
import styled from 'styled-components';
import i18n from '../i18n';
import { Card, CardTitle, CardBody } from '../styled/Card';

const placeData = (data) => {
  const { ads, google_search, social_networks, recommendation, not_specified } = data;

  return ({
    labels: [
      i18n.t('clientSourcing.socials'),
      i18n.t('clientSourcing.recs'),
      i18n.t('clientSourcing.ads'),
      i18n.t('clientSourcing.google'),
      i18n.t('clientSourcing.notSpeced'),
    ],
    datasets: [
      {
        data: [
          ads || 0,
          google_search || 0,
          social_networks || 0,
          recommendation || 0,
          not_specified || 0,
        ],
        backgroundColor: ['#00B97F', '#CCEFF1', '#005938', '#9DD7E7', '#69A4DB'],
      },
    ],
  })
};

const ClientSourcing = (props) => {
  const { client_sourcing } = props.data;

  return (
    <Card>
      <CardTitle>{i18n.t('clientSourcing.title')}</CardTitle>
      <CardBody padding={'20px'}>
        <Pie data={placeData(client_sourcing || {})} />
      </CardBody>
    </Card>
  )
};

export default ClientSourcing;

const Header = styled.div`
  text-align: center;
`;
